import {
    ApplicationConfig,
    importProvidersFrom,
    provideBrowserGlobalErrorListeners,
    provideZoneChangeDetection
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { AuthModule, OidcConfig, OidcConfigParameters } from '@pcscol-portail/ng-auth';
import { Config, ConfigModule, ConfigService } from '@pcscol-portail/composants-pegase';

import {
    Configuration as ChcApiConfiguration,
    ConfigurationParameters as ChcApiConfigurationParameters
} from '@api-chc';
import {
    Configuration as InsApiConfiguration,
    ConfigurationParameters as InsApiConfigurationParameters
} from '@api-ins';
import {
    Configuration as AcsApiConfiguration,
    ConfigurationParameters as AcsApiConfigurationParameters
} from '@api-acs/configuration';
import { AuthzConfig, AuthzConfigParameters, AuthzModule } from '@pcscol-portail/ng-authz';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAapIcons } from './shared/icons/aap-icons.provider';


import { provideAnimations } from '@angular/platform-browser/animations';

import { EffectsModule } from '@ngrx/effects';
import { routes } from './app.routes';
import { BrowserModule } from "@angular/platform-browser";
import { FullRouterStateSerializer, routerReducer, StoreRouterConnectingModule } from "@ngrx/router-store";
import { StoreModule } from "@ngrx/store";
import { environment } from "../environments/environment";
import {
    Configuration as idtApiConfiguration,
    ConfigurationParameters as idtApiConfigurationParameters
} from '@api-idt';

export function authzConfig(configService: ConfigService) {
    return new AuthzConfig(configService.getConfig().authz as AuthzConfigParameters)
}

export function authConfig(configService: ConfigService) {
    return new OidcConfig(configService.getConfig().auth as OidcConfigParameters);
}

export function insApiConfig(configService: ConfigService) {
    return new InsApiConfiguration(configService.getConfig().api.inscription as InsApiConfigurationParameters);
}

export function chcApiConfig(configService: ConfigService) {
    return new ChcApiConfiguration(configService.getConfig().api.chc as ChcApiConfigurationParameters);
}

export function acsApiConfig(configService: ConfigService) {
    return new AcsApiConfiguration(configService.getConfig().api.acs as AcsApiConfigurationParameters);
}

function identiteApiConfig(configService: ConfigService) {
    return new idtApiConfiguration({
        ...configService.getConfig().idt as idtApiConfigurationParameters,
        basePath: configService.getConfig().api.idt.url + 'api/idt/v1'
    })
}


export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({eventCoalescing: true}),
        provideHttpClient(withInterceptorsFromDi()),
        importProvidersFrom(
            // core
            BrowserModule,
            StoreModule.forRoot({router: routerReducer}, {
                metaReducers: [],
                runtimeChecks: {
                    strictStateImmutability: true,
                    strictActionImmutability: true,
                },
            }),
            StoreRouterConnectingModule.forRoot({serializer: FullRouterStateSerializer, stateKey: 'router'}),
            // app
            // DialogModule,
            // theme
            // libs pégase
            AuthModule,
            ConfigModule.forRoot(new Config({location: environment.config})),
            AuthModule.forRoot(),
            AuthzModule.forRoot(),
            StoreModule.forRoot({}, {}),
            StoreRouterConnectingModule.forRoot(),
            EffectsModule.forRoot([])),
        {provide: OidcConfig, useFactory: authConfig, deps: [ConfigService]},
        {provide: AuthzConfig, useFactory: authzConfig, deps: [ConfigService]},
        {provide: InsApiConfiguration, useFactory: insApiConfig, deps: [ConfigService]},
        {provide: idtApiConfiguration, useFactory: identiteApiConfig, deps: [ConfigService]},
        {provide: ChcApiConfiguration, useFactory: chcApiConfig, deps: [ConfigService]},
        {provide: AcsApiConfiguration, useFactory: acsApiConfig, deps: [ConfigService]},
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        provideAapIcons(),
        provideRouter(routes, withRouterConfig({
            // preloadingStrategy: PreloadAllModules,
            // scrollPositionRestoration: 'enabled',
            // anchorScrolling: 'enabled',
            // // paramsInheritanceStrategy: inherit route data, see https://stackoverflow.com/a/50780702
            // paramsInheritanceStrategy: 'always'
            //    bindToComponentInputs: true
        }))
    ]
};
